import { render, staticRenderFns } from "./MapaDesempenho.vue?vue&type=template&id=c4abfc3e&scoped=true"
import script from "./MapaDesempenho.vue?vue&type=script&lang=js"
export * from "./MapaDesempenho.vue?vue&type=script&lang=js"
import style0 from "./MapaDesempenho.vue?vue&type=style&index=0&id=c4abfc3e&prod&lang=css"
import style1 from "./MapaDesempenho.vue?vue&type=style&index=1&id=c4abfc3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4abfc3e",
  null
  
)

export default component.exports